import styles from "./MenuBottomBar.module.css";
import { globals, images } from "../../styles";
import {
  home_Icon,
  news_Icon,
  trophy_Icon,
  groups_Icon,
} from "../../assets/icons";
import { useNavigate } from "../../hooks/useNavigate";
import { Page } from "../../types";
import { useNewsArticle } from "../../hooks/useNewsArticle";
import { useLogout } from "../../hooks/auth";
import LoadingSpinner from "../LoadingSpinner";
import { useActiveDraft } from "../../hooks/drafts";

export enum MenuBarItem {
  Home = "Home",
  News = "News",
  Leaderboards = "Leaderboards",
  Groups = "Groups",
  LogOut = "LogOut",
}

interface MenuBottomBarProps {
  items: MenuBarItem[];
}

function MenuBottomBar({ items }: MenuBottomBarProps) {
  const { navigate } = useNavigate();
  const { unreadCount } = useNewsArticle();
  const { mutate: logout, isPending: isLoggingOut } = useLogout();
  const { data: activeDraft, isPending: isDraftCheckPending } =
    useActiveDraft();

  if (isDraftCheckPending || !activeDraft) {
    return (
      <div className={styles["main-container"]}>
        <div className={styles["btn-container"]}>
          <div className={globals["button-wrapper"]}>
            <LoadingSpinner />
          </div>
        </div>
      </div>
    );
  }

  const buttonMap: Record<MenuBarItem, React.ReactNode> = {
    [MenuBarItem.Home]: (
      <div key={MenuBarItem.Home} className={styles["btn-container"]}>
        <button
          className={globals["button-wrapper"]}
          onClick={() => navigate(Page.Welcome)}
        >
          <img src={home_Icon} className={images["menu-icon"]} alt="" />
        </button>
        <span className={styles["button-text"]}>Home</span>
      </div>
    ),
    // TODO: Re-enable news items
    [MenuBarItem.News]: null,
    // [MenuBarItem.News]: (
    //   <div key={MenuBarItem.News} className={styles["btn-container"]}>
    //     <button
    //       className={globals["button-wrapper"]}
    //       style={{ position: "relative" }}
    //       onClick={() => navigate(Page.News)}
    //     >
    //       <img src={news_Icon} className={images["menu-icon"]} alt="" />
    //       {unreadCount > 0 && (
    //         <span className={styles["news-pip"]}>{unreadCount}</span>
    //       )}
    //     </button>
    //     <span className={styles["button-text"]}>News</span>
    //   </div>
    // ),
    [MenuBarItem.Leaderboards]: (
      <div key={MenuBarItem.Leaderboards} className={styles["btn-container"]}>
        <button
          className={globals["button-wrapper"]}
          onClick={() => navigate(Page.LeaderboardSelection)}
        >
          <img src={trophy_Icon} className={images["menu-icon"]} alt="" />
        </button>
        <span className={styles["button-text"]}>Leaderboards</span>
      </div>
    ),
    [MenuBarItem.Groups]: (
      <div key={MenuBarItem.Groups} className={styles["btn-container"]}>
        <button
          className={globals["button-wrapper"]}
          onClick={() => navigate(Page.Groups)}
        >
          <img src={groups_Icon} className={images["menu-icon"]} alt="" />
        </button>
        <span className={styles["button-text"]}>Groups</span>
      </div>
    ),
    [MenuBarItem.LogOut]: (
      <div key={MenuBarItem.LogOut} className={styles["btn-container"]}>
        <button
          className={globals["button-wrapper"]}
          onClick={() => logout()}
          disabled={isLoggingOut}
        >
          <img src={home_Icon} className={images["menu-icon"]} alt="" />
        </button>
        <span className={styles["button-text"]}>
          {isLoggingOut ? "Logging Out..." : "Log Out"}
        </span>
      </div>
    ),
  };

  return (
    <div className={styles["main-container"]}>
      {items.map((item) => buttonMap[item])}
    </div>
  );

  /** TODO: Implement settings
   * <div className={styles["btn-container"]}>
        <button
          className={globals["button-wrapper"]}
          onClick={() => navigate(Page.Settings)}
        >
          <img src={settings_Icon} className={images["menu-icon"]} alt="" />
        </button>
        <span className={styles["button-text"]}>Settings</span>
      </div> */
}

export default MenuBottomBar;
